import React from 'react';
import { Link } from 'react-router';
import backgroundImage from '../assets/light-grey-marble-texture-background-luxury-look-table-top-.jpg';
import { languageStore } from '../subscriber/Language';

export default function NotFound() {
    const { getPageTranslations } = languageStore;
    const t = getPageTranslations('notFound');

    return (  
        <section className="py-24 relative" style={{ backgroundColor: '#FFEDE1' }}>
            <div className="absolute inset-0 z-0">
                <img
                    src={backgroundImage}
                    alt={t.backgroundAlt}
                    layout="fill"
                    objectFit="cover"
                    className="opacity-10 mix-blend-luminosity"
                />
            </div>
            <div className="min-h-[calc(100vh-280px)] bg-[#FFEDE1] flex items-center justify-center px-4 py-20 sm:px-6 lg:px-8 relative">
                <div className="relative max-w-[1220px] w-full text-center">
                    <h1 className="text-9xl font-bold text-[#1F0707] mb-[-15px]">{t.errorCode}</h1>
                    
                    <div className="mt-2 mb-5">
                        <h2 className="text-4xl font-semibold text-[#1F0707] mb-5">{t.title}</h2>
                        <p className="text-lg text-gray-600">
                            {t.description}
                        </p>
                    </div>
                    
                    <Link to="/" className="inline-block px-10 py-4 text-[#1F0707] border border-[#D3752B] bg-gradient-to-br from-[#D3752B00] to-[#D3752B] hover:from-[#E17F32] hover:to-[#D3752B] transition-all duration-400 ease-in-out font-medium">
                        {t.backToHome}
                    </Link>
                </div>
            </div>
        </section>
    );
}
